import { building } from "$app/environment";

import { redirectToDocs, resolveDocsRedirect } from "$lib/docs/redirects";
import type { LayoutLoad } from "./$types";

// Applies the docs redirect table on client-side navigation, which never
// reaches `handleDocsRedirects` (hooks.server.ts) for pages without a server
// load. On the server the hook has already redirected, so this only fires in
// the browser. Reading `url.pathname` makes the load rerun on every docs
// navigation, and the router follows the thrown redirect.
export const load: LayoutLoad = ({ url }) => {
  const target = resolveDocsRedirect(url.pathname);
  if (target) {
    // `url.search` throws while prerendering; prerendered pages are never
    // redirect sources because the hook handled them first.
    redirectToDocs(target, building ? "" : url.search, url.hash);
  }
};
